import { render, staticRenderFns } from "./DocumentForm.vue?vue&type=template&id=5f073b41&"
import script from "./DocumentForm.vue?vue&type=script&lang=js&"
export * from "./DocumentForm.vue?vue&type=script&lang=js&"
import style0 from "./DocumentForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/kreston-is.sdev.cz/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f073b41')) {
      api.createRecord('5f073b41', component.options)
    } else {
      api.reload('5f073b41', component.options)
    }
    module.hot.accept("./DocumentForm.vue?vue&type=template&id=5f073b41&", function () {
      api.rerender('5f073b41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/forms/documents/DocumentForm.vue"
export default component.exports